import React, {useEffect, useState} from 'react';
import './AdminPartnersPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import {API_BASE} from '../../../utils/apiConfig';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';
import {formatMatchDate} from '../../../utils/date/formatMatchDate';

const PAGE_ID = 'AdminPartnersPage';

/**
 * Админка, раздел «Партнеры»: все пользователи, когда-либо назначенные
 * партнерами (включая приостановленных). Плашки — как в «Списке
 * пользователей», плюс число зарегистрированных по партнерской ссылке и
 * статус активности. Клик — в профиль пользователя-партнера.
 */
function AdminPartnersPage({onPartnerClick, onBack}) {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  usePageAnalytics('AdminPartnersPage');

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const res = await fetch(`${API_BASE}/admin/partners`, {credentials: 'include'});
        if (!res.ok) throw new Error('Failed to fetch partners');
        const data = await res.json();
        setPartners(data.partners || []);
      } catch (e) {
        console.error('Fetch partners error', e);
        setError('Не удалось загрузить партнеров');
      } finally {
        setLoading(false);
      }
    };

    fetchPartners();
  }, []);

  return (
    <>
      <h1 className="lobby-page-title">Партнеры</h1>

      <div className="admin-users-list">
        {loading && <div className="admin-users-status">Загрузка...</div>}
        {error && <div className="admin-users-status">{error}</div>}
        {!loading && !error && partners.length === 0 && (
          <div className="admin-users-status">Партнеров пока нет</div>
        )}
        {!loading &&
          !error &&
          partners.map((partner) => (
            <PageButton
              key={partner.id}
              className="admin-user-item"
              pageId={PAGE_ID}
              buttonId={`partner_${partner.id}`}
              onClick={() => onPartnerClick(partner.id, partner.login)}
            >
              <span className="admin-user-item-name">
                {partner.login}
                <span
                  className={`admin-partner-item-status ${partner.isActivePartner ? 'admin-partner-item-status_active' : 'admin-partner-item-status_inactive'}`}
                >
                  {partner.isActivePartner ? 'активен' : 'приостановлен'}
                </span>
              </span>
              <span className="admin-partner-item-referrals">
                Регистраций по ссылке: <b>{partner.referralsCount}</b>
              </span>
              <span className="admin-user-item-dates">
                <span>Партнер с: {formatMatchDate(partner.partnerActivatedAt)}</span>
                <span>Вход: {formatMatchDate(partner.lastOnlineAt)}</span>
              </span>
            </PageButton>
          ))}
      </div>

      <div className="main-menu-buttons">
        <PageButton onClick={onBack} pageId={PAGE_ID} buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default AdminPartnersPage;
